import RestApiModel from "@/api/Model/RestApiModel";
import api from "@/api";

class ProductCategory extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-category-ipr';
  }

  /**
   * @returns {*}
   */
  static riskClasses() {
    return api.get(`${this.getResourceEndpoint()}/risk-classes`);
  }

  /**
   * @returns {*}
   */
  static subRiskClasses() {
    return api.get(`${this.getResourceEndpoint()}/sub-risk-classes`);
  }
}

export default ProductCategory;
